const getFromStorage = (key) => {
    if (typeof window !== 'undefined') {
        return localStorage.getItem(key)
    }
}
const setToStorage = (key, value) => {
    if (typeof window !== 'undefined') {
        return localStorage.setItem(key, value)
    }
}

export function getCartToken() {
    let cartId = getFromStorage('cartId');

    if (cartId === "null")
        return null;

    return cartId;
}

export function setCartToken(token) {
    return setToStorage('cartId', token);
}


export function setSuccessOrderId(orderId) {
    return setToStorage('orderId', orderId);
}

export function getSuccessOrderId() {
    return getFromStorage('orderId');
}


export function setSuccessOrderProtectCode(protectCode) {
    return setToStorage('protectCode', protectCode);
}

export function getSuccessOrderProtectCode() {
    return getFromStorage('protectCode');
}